import { Maximize2 } from "lucide-react";
import { GALLERY } from "../../data/content";
import { Link } from "react-router-dom";
import { Flag } from "lucide-react";
import { Lightbox, useLightbox } from "./Lightbox";
import { useEventi } from "./NewsTicker";

export const Gallery = () => {
  const lb = useLightbox();
  const gare = useEventi(2026);
  return (
    <section
      id="galleria"
      data-testid="gallery-section"
      className="py-24 bg-neutral-900 border-b border-neutral-800"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h2 className="font-display text-3xl sm:text-4xl font-black uppercase text-white">
            Galleria Legend
          </h2>
          <p className="text-sm text-neutral-400 mt-1">
            Auto da rally della scuderia, officina e negozio Legend. Clicca una foto per ingrandirla.
          </p>
        </div>
        <div data-testid="gare-buttons" className="flex flex-wrap items-center gap-2 mb-8">
          <span className="mono-label text-xs uppercase tracking-wider text-red-500 mr-2 inline-flex items-center gap-2"><Flag className="w-4 h-4" /> Gallerie gare 2026</span>
          {gare.map((e) => (
            <Link
              key={e.id}
              to={`/gare/${e.slug}`}
              data-testid={`gara-btn-${e.slug}`}
              className="px-4 py-2 border border-neutral-700 hover:border-red-600 bg-neutral-950 text-neutral-200 hover:text-red-500 text-xs font-black uppercase tracking-widest transition-colors"
            >
              {e.titolo}
            </Link>
          ))}
          <Link to="/gare" data-testid="gare-all" className="px-4 py-2 bg-red-600 hover:bg-red-500 text-white text-xs font-black uppercase tracking-widest transition-colors">
            Tutte le gare &rarr;
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {GALLERY.map((g, i) => (
            <figure
              key={g.src}
              data-testid={`gallery-item-${i + 1}`}
              className="group relative border border-neutral-800 overflow-hidden"
            >
              <button
                type="button"
                data-testid={`gallery-open-${i + 1}`}
                onClick={() => lb.open(i)}
                aria-label={`Ingrandisci: ${g.label}`}
                className="block w-full cursor-zoom-in"
              >
                <img
                  src={g.src}
                  alt={g.label}
                  className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-2 right-2 w-8 h-8 bg-neutral-950/80 border border-neutral-700 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity">
                  <Maximize2 className="w-4 h-4" />
                </span>
              </button>
              <figcaption className="absolute inset-x-0 bottom-0 p-3 bg-neutral-950/85 mono-label text-[11px] uppercase tracking-wider text-neutral-300 pointer-events-none">
                {g.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
      <Lightbox items={GALLERY} index={lb.index} onClose={lb.close} onChange={lb.change} />
    </section>
  );
};
